import { DependencyList, useCallback } from 'react'
import {
  ApiGetWithToken,
	useApiFetchList
} from 'shared/api'
import {
	auditLogApi
} from 'interface/endpoints'
import {
  AuditLogResult,
	AuditLogResultList
} from './types'

export * from './types'

export const useListAuditLog = (
	option: {
		partialLimit?: number
		from?: string | null
		to?: string | null
		onPreFetch?: () => void
		onFetched?: (result: AuditLogResult[]) => void
	} = {},
	deps?: DependencyList
) => {
	const { partialLimit, from, to, onPreFetch, onFetched } = option
	return useApiFetchList<AuditLogResult, AuditLogResult[]>(
		useCallback(
			(apiAccess, cancelToken) => {
				if (onPreFetch) onPreFetch()
				if (!from && !to) return 0
				return ApiGetWithToken<number>(
					apiAccess,
					auditLogApi('/count', {
						from: from ?? undefined,
						to: to ?? undefined
					}),
					cancelToken
				)
			},
			[from, to, onPreFetch]
		),
		useCallback(
			(apiAccess, cancelToken, offset, limit) => {
				if (!from && !to) return []
				const wrapper = async () => {
					const list = await ApiGetWithToken<AuditLogResultList>(
						apiAccess,
						auditLogApi('/list', {
							from: from ?? undefined,
							to: to ?? undefined,
							offset, limit
						}),
						cancelToken
					)
					return list?.list
				}
				return wrapper()
			},
			[from, to]
		),
		useCallback(
			(result) => {
				if (onFetched) onFetched(result)
				return result
			},
			[onFetched]
		),
		partialLimit ?? 1000,
		deps
	)
}
